import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { filmFacts, viewingHints } from "@/mocks/film";

export default function FilmInfo() {
  return (
    <section id="intro" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="Film Overview"
              title="影片简介与基本信息"
              desc="在进入剧情之前，先用一屏把这部片子的来龙去脉交代清楚：它是什么类型、由谁创作、改编自什么作品，以及观看时需要注意什么。"
            />
          </Reveal>

          <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
            <Reveal className="lg:col-span-7" delay={60}>
              <div className="h-full p-6 md:p-8 rounded-lg bg-background-50 border border-background-200">
                <span className="inline-flex items-center gap-2 font-label text-xs tracking-widest uppercase text-secondary-600">
                  <i className="ri-quote-text" />
                  Synopsis
                </span>
                <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  一个人的成长，被一段旅程照见
                </h3>
                <div className="mt-4 space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
                  <p>
                    《一路向西》是一部 2012 年在香港上映的粤语电影，类型上融合了喜剧与爱情，整体带有强烈的自传体与黑色幽默色彩。
                    故事围绕主角“向西”展开，从他少年时期的懵懂，到远赴英国求学时遭遇的观念冲击，再到经历一段无疾而终的感情，
                    层层铺垫出他踏上“北上”旅程的心理动因。
                  </p>
                  <p>
                    表面上，这是一场追求新鲜与刺激的出游；实际上，影片借这段旅程讨论的是更普遍的问题：
                    当一个人分不清欲望与情感的区别时，他做的每一个选择究竟是为了什么。片中形形色色的人和事，
                    共同构成了一面镜子，映出主角内心的摇摆与空白。
                  </p>
                  <p>
                    影片改编自网络连载小说，原作以第一人称、口语化的方式记录年轻人的真实心绪。电影在改编时保留了大量自述式旁白，
                    使整部作品始终带着“有人在你耳边讲自己的故事”的私密感，也让它在同类题材里显得格外坦率。
                  </p>
                </div>

                <div className="mt-6 flex flex-wrap gap-2">
                  {["自传体", "黑色幽默", "成长题材", "网络小说改编", "港产喜剧"].map((tag) => (
                    <span
                      key={tag}
                      className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>

            <Reveal className="lg:col-span-5" delay={140}>
              <div className="h-full p-6 md:p-8 rounded-lg bg-foreground-950 text-background-100">
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 flex items-center gap-2">
                  <i className="ri-information-line text-accent-400" />
                  基本信息
                </h3>
                <dl className="mt-5 divide-y divide-white/10">
                  {filmFacts.map((fact) => (
                    <div
                      key={fact.label}
                      className="flex items-start justify-between gap-4 py-3"
                    >
                      <dt className="font-label text-xs md:text-sm text-background-300 shrink-0">
                        {fact.label}
                      </dt>
                      <dd className="text-sm md:text-base text-background-50 text-right">
                        {fact.value}
                      </dd>
                    </div>
                  ))}
                </dl>
              </div>
            </Reveal>
          </div>

          <div className="mt-6 md:mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {viewingHints.map((hint, index) => (
              <Reveal key={hint.title} delay={index * 80}>
                <div className="h-full flex gap-4 p-5 rounded-lg bg-background-50 border border-background-200">
                  <span className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                    <i className={`${hint.icon} text-xl`} />
                  </span>
                  <div>
                    <h4 className="font-heading text-base font-bold text-foreground-950">
                      {hint.title}
                    </h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                      {hint.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}